<template lang="pug">
validation-observer(ref="obs" v-slot="{ handleSubmit }")
  sdo-dialog(:button-options="buttonOptions" ref="dialog")
    template(v-slot:header) {{ isEditing ? 'Изменить метку' : 'Добавить метку' }}
    template(v-slot:body)
        validation-provider(
          rules="required"
          name="Название метки"
          vid="name"
          v-slot="{ errors, valid }"
        )
          v-text-field(
            v-model="tag.name"
            label="Название метки"
            :error-messages="errors"
            rounded filled
          )

        validation-provider(
          rules="required"
          name="Цвет метки"
          vid="color"
          v-slot="{ errors, valid }"
        )
          v-color-picker(v-model="tag.color" mode="hexa" hide-mode-switch)

        p Предпросмотр:
          v-chip.ml-2(:color="tag.color" :dark="isDark") {{ tag.name }}

    template(v-slot:actions)
      v-spacer
      v-btn(@click="handleSubmit(saveTag)" :loading="loading" color="success" text) Сохранить
      v-btn(@click="close" color="warning" text) Отмена
</template>

<script>
import SdoDialog from '@/components/Global/SdoDialog.vue';
import { invertColor } from '@/utils/color-functions';

export default {
  name: 'CreateTagDialog',
  components: { SdoDialog },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tag: {
        name: '',
        color: '#FFFFFF',
      },
      loading: false,
    };
  },
  computed: {
    isDark() {
      return invertColor(this.tag.color, true);
    },
    buttonOptions() {
      return {
        label: this.isEditing ? '' : 'Добавить метку',
        color: this.isEditing ? 'warning' : 'success',
        fab: this.isEditing,
        icon: this.isEditing ? 'mdi-pencil' : 'mdi-plus',
      };
    },
    isEditing() {
      return !!this.initialData.id;
    },
  },
  mounted() {
    if (this.initialData.id) this.tag = this.initialData;
  },
  methods: {
    saveTag() {
      this.loading = true;
      const request = this.isEditing
        ? this.$api.tag.update(this.tag.id, this.tag)
        : this.$api.tag.create(this.tag);
      this.$rHandler(
        request,
        () => {
          this.loading = false;
          this.close();
          this.$emit('save', { ...this.tag });
          if (!this.isEditing) {
            this.tag.name = '';
            this.tag.color = '#FFFFFF';
          }
        },
        () => {
          this.loading = false;
        },
      );
    },
    close() {
      this.$refs.dialog.close();
    },
  },
};
</script>

<style scoped>

</style>
